<template>
 <div>
  <b-form @submit.prevent="onSubmit">
    <!-- Name -->
    <b-form-group :label="$t('Name')" label-for="name">
      <b-form-input id="name" v-model="planData.name" autofocus :state="errors && ('name' in errors) ? false : null"
        trim autocomplete="off" placeholder="" />
      <b-form-invalid-feedback v-if="errors && ('name' in errors)" :state="errors && ('name' in errors) ? false : null">
        {{ errors.name[0] }}
      </b-form-invalid-feedback>
    </b-form-group>


    <!-- device -->
    <b-form-group :label="$t('Device')" label-for="device" :state="null">
      <v-select v-model="planData.device_id" label="name" :reduce="val => val.device_id"
        :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :options="devicesOptions" :clearable="true"
        input-id="device" />

      <b-form-invalid-feedback v-if="errors && ('device_id' in errors)"
        :state="errors && ('device_id' in errors) ? false : null">
        {{ errors.device_id[0] }}
      </b-form-invalid-feedback>
    </b-form-group>


    <b-row>
      <b-col cols="12">
        <!-- Camp -->
        <b-form-group :label="$t('Camp')" label-for="camp" :state="null">
          <v-select v-model="planData.camp_id" label="name" :reduce="val => val.geofence_id"
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :options="campsOption" :clearable="false"
            input-id="camp" />
          <b-form-invalid-feedback v-if="errors && ('camp_id' in errors)"
            :state="errors && ('camp_id' in errors) ? false : null">
            {{ errors.camp_id[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>





      <b-col cols="12">
        
        
          <pest-area-form-repeater :items.sync="workAreaItems" :options="workAreaOption">
            <template v-slot:error>
              <b-form-invalid-feedback v-if="errors && ('work_areas' in errors)"
                                       :state="errors && ('work_areas' in errors) ? false : null">
                {{ errors.work_areas[0] }}
              </b-form-invalid-feedback>
            </template>
          </pest-area-form-repeater>
       
      </b-col>





    </b-row>

    

    <!-- Form Actions -->
    <div class="d-flex mt-2">
      <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" type="submit">
        {{ $t('Save') }}
      </b-button>
    </div>
  </b-form>

  </div>
</template>

<script>

import {
  BCol, BRow, BFormGroup, BFormInvalidFeedback, BFormRadioGroup, BFormCheckboxGroup,
  BButton, BForm, BFormInput, BFormCheckbox,
} from 'bootstrap-vue'
import PestAreaFormRepeater from '@/components/form/PestAreaFormRepeater'
import { onUnmounted, ref,watch } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import store from '@/store'
import formGetLinkedOptions from '@/views/modules/api/formGetLinkedOptions'

export default {
  name: 'PestPlanForm',
  props: ['errors', 'planData', 'onSubmit','workAreaItems'],
  components: {
    PestAreaFormRepeater, BButton, BFormCheckboxGroup, BFormCheckbox,
    flatPickr, vSelect, BForm, BFormInput,
    BCol, BRow, BFormGroup, BFormInvalidFeedback, BFormRadioGroup
  },
  directives: {
    Ripple,
  },
  setup(props, { root }) {
  
  
   
    const user = store.getters['auth/user']

    if (!store.hasModule('formOptions'))
      store.registerModule('formOptions', formGetLinkedOptions)

    onUnmounted(() => {
      if (store.hasModule('formOptions'))
        store.unregisterModule('formOptions')
    })

    const campsOption = ref([])
    const workAreaOption = ref([])
    const devicesOptions = ref([])


    const flatPickerConfig = {
      enableTime: true,
      noCalendar: true,
      time_24hr: true,
      dateFormat: 'H:i:S',
    }


   

    const setOptions = area => {
      // console.log('the area is ',area)
      switch (area.category) {
        case 'CAMP_AREA': campsOption.value.push(area); break
        case 'WORK_AREA': workAreaOption.value.push(area); break

      }
    }

    store.dispatch('formOptions/getLinkedOptions', {
      user: user.id,
      type: 'geofence',
      cols: 'geofence_id,name,category'
    }).then(res => res.data.data.map(a => setOptions(a))).catch(reason => { })


    store.dispatch('formOptions/getLinkedOptions', {
      user: user.id,
      type: 'device',
      cols: 'device_id,name'
    }).then(res => devicesOptions.value = res.data.data).catch(reason => { })


    return {
     
      flatPickerConfig,
      campsOption, workAreaOption,  devicesOptions,
     
    }

  }
}
</script>

<style scoped>

</style>
